"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.createBreakpointComponents = exports.Breakpoint = void 0;
var _reactResponsive = _interopRequireDefault(require("react-responsive"));
var _jsxRuntime = require("react/jsx-runtime");
const Breakpoint = function (_ref) {
  let {
    up = false,
    down = false,
    minWidth,
    maxWidth,
    children,
    ...props
  } = _ref;
  if (!children) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactResponsive.default, {
    ...props,
    maxWidth: up ? undefined : maxWidth,
    minWidth: down ? undefined : minWidth,
    "data-testid": "Breakpoint",
    children: children
  });
};
exports.Breakpoint = Breakpoint;
const createBreakpointComponents = function (breakpoints) {
  return {
    MobileBreakpoint: function (props) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(Breakpoint, {
        maxWidth: breakpoints.mobile,
        ...props,
        "data-testid": "createBreakpointComponents"
      });
    },
    TabletBreakpoint: function (props) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(Breakpoint, {
        minWidth: breakpoints.mobile + 1,
        maxWidth: breakpoints.tablet,
        ...props,
        "data-testid": "createBreakpointComponents"
      });
    },
    DesktopBreakpoint: function (props) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(Breakpoint, {
        minWidth: breakpoints.tablet + 1,
        maxWidth: breakpoints.desktop,
        ...props,
        "data-testid": "createBreakpointComponents"
      });
    },
    XLDesktopBreakpoint: function (props) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(Breakpoint, {
        minWidth: breakpoints.desktop + 1,
        ...props,
        "data-testid": "createBreakpointComponents"
      });
    }
  };
};
exports.createBreakpointComponents = createBreakpointComponents;
var _default = exports.default = Breakpoint;